import PurchaseRequestDetailFilterHeader from './PurchaseRequestDetailFilterHeader';
import PurchaseRequestDetailTable from './PurchaseRequestDetailTable';

const PurchaseRequestDetailPage = () => {
  return (
    <>
      <div className={'page-wrapper'}>
        <PurchaseRequestDetailFilterHeader />
        <PurchaseRequestDetailTable />
      </div>
    </>
  );
};

export default PurchaseRequestDetailPage;
